var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product',{attrs:{"title":"Amazfit 智能手表 2 复仇者联盟系列限量版","swiper-data":_vm.swiperData,"slogan":_vm.slogan,"price":"1499","colors":_vm.colors,"detail-images":_vm.detailImages,"param-images":_vm.paramImages,"buy-link":"https://j.youzan.com/0uz1Kh","is-bus-city1":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }